import { Pipe, PipeTransform } from '@angular/core';
import { CardOrderingItemStatus } from '@app/shared/enums/CardOrderingItemStatus.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'cardOrderingItemStatus',
    standalone: false
})
export class CardOrderingItemStatusPipe implements PipeTransform {
  public cardOrderingItemStatus = CardOrderingItemStatus;
  public cardOrderingItemStatusList: any[] = [];

  constructor(public translate: TranslateService) { }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(CardOrderingItemStatus).find(
          k => CardOrderingItemStatus[k as keyof typeof CardOrderingItemStatus] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.cardOrderingItemStatusList = [];

    for (const [propertyKey, propertyValue] of Object.entries(CardOrderingItemStatus)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.cardOrderingItemStatusList.push({ id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) });
    }

    return this.cardOrderingItemStatusList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(CardOrderingItemStatus)) {
      if (propertyValue == Id) {
        return { id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(CardOrderingItemStatus)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
